export const CALENDAR_AGENT_GPT_ID = "T_424ef713-95a1-2947-7c16-8f9fcdae4276.1e19ddd4-7157-4397-95b0-dccd1cf55978";
